import moment from "moment";
import React from "react";

const fmt = require("indian-number-format");

export default function LedgerCard(props) {
  const item = props.item;

  return (
    <div className="menuContainer addHight text">
      <div className="menuExchange">
        {item.deposit > 0 ? (
          <div
            className="text"
            style={{ display: "flex", textTransform: "uppercase" }}
          >
            {item.wallet == 1 ? (
              <div className="buytext">Wallet-Deposit : </div>
            ) : (
              <div className="buytext">Deposit : </div>
            )}

            <div style={{ paddingLeft: 5 }}>{fmt.format(item.deposit)}</div>
          </div>
        ) : null}
        {item.withdraw > 0 ? (
          <div
            className="text"
            style={{ display: "flex", textTransform: "uppercase" }}
          >
            {item.wallet == 1 ? (
              <div className="selltext">Wallet-Withdraw : </div>
            ) : (
              <div className="selltext">Withdraw : </div>
            )}

            <div style={{ paddingLeft: 5 }}>{fmt.format(item.withdraw)}</div>
          </div>
        ) : null}
        {item.credit > 0 ? (
          <div
            className="text"
            style={{ display: "flex", textTransform: "uppercase" }}
          >
            <div className="primarytext">Cash Balance : </div>{" "}
            <div style={{ paddingLeft: 5 }}>{fmt.format(item.credit)}</div>
          </div>
        ) : null}
        {item.weekly_amt !== 0 ? (
          <div
            className="text"
            style={{ display: "flex", textTransform: "uppercase" }}
          >
            <div className="text">Weekly Balance : </div>{" "}
            <div
              className={item.weekly_amt > 0 ? "buytext" : "selltext"}
              style={{ paddingLeft: 5 }}
            >
              {fmt.format(item.weekly_amt)}
            </div>
          </div>
        ) : null}
      </div>
      <div className="menuExchange uppercase">{item.remarks}</div>

      <div className="menuExchange">
        {moment(item.date_created).format("DD-MM-YYYY HH:mm:ss")}
      </div>
    </div>
  );
}
